module.exports = "/packs/media/images/outcome-fees-86d03a818c7ee661e5c6ae87afc20238.png";